module.exports = __webpack_public_path__ + "static/media/Location.eb4bc2d9.png";